import React, { useState, useEffect } from "react"
import { Parallax } from "react-parallax"

export default function ParallaxSection({ src, altTag, height }) {
  const [width, setWidth] = useState(0)

  useEffect(() => {
    if (typeof window === `undefined`) return

    setWidth(window.innerWidth)
  }, [typeof window !== `undefined` ? window.innerWidth : 0])

  if (!src) return null

  return (
    <Parallax
      // blur={1}
      bgImage={src}
      bgImageAlt={altTag}
      strength={700}
      disabled={width <= 1024}
    >
      <div
        style={{ height: width > 1500 ? 635 : width <= 1024 ? 150 : height }}
      />
    </Parallax>
  )
}

ParallaxSection.defaultProps = {
  altTag: "LTC",
  height: 400,
  src: "",
}
